module.exports = __webpack_public_path__ + "static/media/aout.7382ecd2.png";